import Card from '@Utils/Card';
import React from 'react';
import './surveyBaseStyles.scss';
import InputSelector from '@Component/form/InputSelector';
import { useQuestionContext } from './questionsSection';

function SurveyExitPoint(props) {
  const attributes = useQuestionContext();

  return (
    <Card>
      <div className="question-header">
        <span className="section-title">Exit Point(s)</span>
      </div>
      <div
        id="exitpoint-editor"
        className="question-content question-with-content"
      >
        <InputSelector
          {...attributes}
          isRich
          type="rich"
          showAttributePicker
          showEmojiPicker
          placeholder="exit point..."
          value={props?.value?.body ?? ''}
          onChange={(body) => {
            props.onChange({ ...props?.value, body });
          }}
        />
      </div>
    </Card>
  );
}

export { SurveyExitPoint };
